(function () {
  'use strict';

  document.querySelectorAll('[data-accordions]').forEach(function (group) {
    if (group.dataset.accordionBound === 'true') return;
    group.dataset.accordionBound = 'true';

    var accordions = Array.prototype.slice.call(group.querySelectorAll('[data-accordion-toggle]'));

    function closeOne(toggle) {
      var body = toggle.parentElement.querySelector('[data-accordion-body]');
      var sign = toggle.querySelector('[data-accordion-sign]');
      if (body) body.classList.add('hide');
      if (sign) sign.textContent = '+';
    }

    function openOne(toggle) {
      var body = toggle.parentElement.querySelector('[data-accordion-body]');
      var sign = toggle.querySelector('[data-accordion-sign]');
      if (body) body.classList.remove('hide');
      if (sign) sign.textContent = '−';
    }

    accordions.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var body = toggle.parentElement.querySelector('[data-accordion-body]');
        var isCurrentlyOpen = body && !body.classList.contains('hide');

        accordions.forEach(closeOne);

        if (!isCurrentlyOpen) openOne(toggle);
      });
    });
  });
})();
